import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SearchUiService {
  public readonly isOpen = signal(false);
  private triggerElement: HTMLElement | null = null;

  public open(trigger?: HTMLElement): void {
    if (trigger) {
      this.triggerElement = trigger;
    }
    this.isOpen.set(true);
  }

  public close(): void {
    this.isOpen.set(false);
    this.triggerElement?.focus();
    this.triggerElement = null;
  }
}
